import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

type ImportStatusModalProps = {
	isError: boolean
	isOpen: boolean
	toggle: () => void
	message: string
};

export const ImportStatusModal = ({
	isError,
	isOpen,
	toggle,
	message,
}: ImportStatusModalProps) => {

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog open={isOpen} onClose={() => toggle()} className="relative z-[100]">
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-black/30" aria-hidden="true" />
				</Transition.Child>
				<div className="fixed inset-0 flex items-center justify-center p-4">
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 scale-95"
						enterTo="opacity-100 scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 scale-100"
						leaveTo="opacity-0 scale-95"
					>
						<Dialog.Panel className={`flex flex-col justify-center ${isError ? 'w-1/3' : 'w-1/2'} p-8 mx-auto bg-white rounded h-1/4`}>
							<Dialog.Title className="mb-4 text-2xl font-semibold text-center uppercase text-primary-blue">
								{isError ? 'Import Unsuccessful' : 'Import Successful'}
							</Dialog.Title>
							<p className={`${isError ? 'mx-10' : 'mx-20'} mb-10 text-lg text-center`}>
								{message}
							</p>
							<div className='flex flex-row justify-center w-full'>
								<button
									className='uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-white bg-primary-blue text-base font-semibold rounded-md shadow-sm hover:bg-white border hover:text-primary-blue hover:border-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:cursor-not-allowed disabled:border-gray-500 disabled:text-gray-500 disabled:bg-white diabled:bg-transparent'
									onClick={() => toggle()}
								>
									continue markup
								</button>
							</div>
						</Dialog.Panel>
					</Transition.Child>
				</div>
			</Dialog>
		</Transition>
	)
}
